__turbopack_context__.v({
  "checkbox": "PriceRefinement-module-scss-module__iA7s9W__checkbox",
  "fill": "PriceRefinement-module-scss-module__iA7s9W__fill",
  "item": "PriceRefinement-module-scss-module__iA7s9W__item",
  "label": "PriceRefinement-module-scss-module__iA7s9W__label",
  "labelText": "PriceRefinement-module-scss-module__iA7s9W__labelText",
  "level": "PriceRefinement-module-scss-module__iA7s9W__level",
  "levels": "PriceRefinement-module-scss-module__iA7s9W__levels",
  "list": "PriceRefinement-module-scss-module__iA7s9W__list",
  "root": "PriceRefinement-module-scss-module__iA7s9W__root",
  "slider": "PriceRefinement-module-scss-module__iA7s9W__slider",
  "thumb": "PriceRefinement-module-scss-module__iA7s9W__thumb",
  "thumbMax": "PriceRefinement-module-scss-module__iA7s9W__thumbMax",
  "thumbMin": "PriceRefinement-module-scss-module__iA7s9W__thumbMin",
  "track": "PriceRefinement-module-scss-module__iA7s9W__track",
});
